import axios from "axios";
import { BASE_URL } from "./urlConfig";
import { store } from "../index";

let token;
if (typeof window !== "undefined") {
  token = localStorage.getItem("adminToken");
}

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    Authorization: token ? `Bearer ${token}` : "",
  },
});

axiosInstance.interceptors.request.use((req) => {
  const { auth } = store.getState();
  if (auth?.token) {
    req.headers.Authorization = `Bearer ${auth?.token}`;
  }
  return req;
});

axiosInstance.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      // Handle unauthorized access, e.g., redirect to login
      if (typeof window !== "undefined") {
        localStorage.removeItem("adminToken");
        localStorage.removeItem("admin");
        store.dispatch({ type: "ADMIN_LOGOUT" });
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  },
);

export default axiosInstance;
